import React from 'react';
import ExternalLinkButton from '../ExternalLinkButton';
import { useI18n } from '../../../../data/hooks/i18nHooks';

const ExternalMeetingLinkButton = (props) => {
    const { virtualroom_url } = props,
        i18n = useI18n();

    return (
        <ExternalLinkButton
            {...props}
            session_content_url={virtualroom_url}
            session_content_button_label={i18n['button.enter_meeting']}
            session_content_type="virtual_room"
            session_content_url_target="iframe"
        />
    );
};

export default ExternalMeetingLinkButton;
